import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { VueUserSessionService, WINDOW } from '@vue/vueframework';
import { SessionDataService } from '../services/session-data.service';
import { PasswordResetWindow } from '../types/PasswordResetWindow';
import { Client } from '../types/Client';
import { AppConfigService } from '../services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class AccountRecoveryUtil {
  private readonly defaultLoginUrl = 'https://wsr.pearsonvue.com/testtaker/signin/SignInPage.htm?clientCode=';
  public constructor(private route: ActivatedRoute,
    private router: Router,
    private sessionDataService: SessionDataService,
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @Inject(WINDOW) private vueWindow: any,
    private appConfig: AppConfigService,
    private vueUserSessionService: VueUserSessionService
  ) {}

  public applyClient(client: Client): void {
    if (client) {
      this.sessionDataService.setClient(client);
      this.sessionDataService.setLoginURL(client.loginURL);
      this.vueUserSessionService.setSelectedClient({ code: client.clientCode ?
        client.clientCode.toUpperCase() : '' });
    } else {
      this.navigateToNotFound();
    }
  }

  public navigateToLogin(): void {
    !this.sessionDataService.getLoginURL() ?
      this.vueWindow.open(this.defaultLoginUrl + this.route.snapshot.params.clientCode, '_self') :
      this.vueWindow.open(this.sessionDataService.getLoginURL(), '_self');
  }

  public navigateToNotFound(): void {
    this.router.navigate([ '/notfound' ]);
  }
  public navigateToRetrieveUsername(clientCode: string): void {
    this.router.navigate([ '/username/lookup', clientCode ], { queryParamsHandling: 'preserve' });
  }
  public navigateToDisplayUsername(clientCode: string): void {
    this.router.navigate([ '/username/display', clientCode ], { queryParamsHandling: 'preserve' });
  }
  public navigateToRetrievePassword(clientCode: string): void {
    this.router.navigate([ '/passwordreset/usernamelookup', clientCode ], { queryParamsHandling: 'preserve' });
  }
  public navigateToResetOptionsPW(clientCode: string): void {
    this.router.navigate([ '/passwordreset/options', clientCode ], { queryParamsHandling: 'preserve' });
  }
  public navigateToVerify(clientCode: string): void {
    this.router.navigate([ '/passwordreset/verify', clientCode ], { queryParamsHandling: 'preserve' });
  }
  public navigateToPasswordUpdate(clientCode: string, passwordResetWindow: PasswordResetWindow): void {
    if (passwordResetWindow.id !== null && passwordResetWindow.hash !== null) {
      this.router.navigate([ '/passwordreset/update', passwordResetWindow.id,
        passwordResetWindow.hash, clientCode ], { queryParamsHandling: 'preserve' });
    }
  }
  public getServiceURL(): string {
    return this.appConfig.getAPIUrl();
  }

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  public getNewRelic(): any {
    return this.vueWindow.newrelic;
  }

  public getLocaleFromUrl(): string {
    let locale = this.sessionDataService.getLocale() ? this.sessionDataService.getLocale() : 'en_US';
    if (this.vueWindow.location.search.indexOf('locale') > -1) {
      const queryParamsAsArray = this.vueWindow.location.search.split('&');
      queryParamsAsArray.forEach((queryParam) => {
        if (queryParam.indexOf('locale') > -1) {
          locale = queryParam.split('=')[ 1 ];
        }
      });
    }
    return locale ? locale : 'en_US';
  }
}
